var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sort-icons" },
    [
      _c(
        "v-icon",
        {
          attrs: { color: _vm.sortDir === "asc" ? "warning" : undefined },
          on: {
            click: function($event) {
              return _vm.$emit("change", "asc")
            }
          }
        },
        [_vm._v("\n    expand_less\n  ")]
      ),
      _vm._v(" "),
      _c(
        "v-icon",
        {
          attrs: { color: _vm.sortDir === "desc" ? "warning" : undefined },
          on: {
            click: function($event) {
              return _vm.$emit("change", "desc")
            }
          }
        },
        [_vm._v("\n    expand_more\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }